export type QueryParams = Record<string, unknown>;

const appendParam = (
  search: URLSearchParams,
  key: string,
  value: unknown
): void => {
  if (value == null) {
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => appendParam(search, `${key}[]`, item));
    return;
  }

  if (typeof value === 'object') {
    Object.entries(value).forEach(([childKey, childValue]) =>
      appendParam(search, `${key}[${childKey}]`, childValue)
    );
    return;
  }

  search.append(key, String(value));
};

/**
 * Serializes a params object into a query string, including the leading `?`,
 * or an empty string when no usable params are present.
 *
 * - `undefined` and `null` values are omitted rather than sent.
 * - Other falsey-like values (empty strings, booleans, and numbers) are always sent, including `false` and `0`.
 * - Arrays are appended as repeated `key[]` entries, per Rails' array param convention.
 */
export const toQuery = (params: QueryParams): string => {
  const search = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) =>
    appendParam(search, key, value)
  );

  const query = search.toString();
  return query ? `?${query}` : '';
};
